'use client';

import type { ReactNode } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

/** Maps JS API version every provider in the app loads. */
const GOOGLE_MAPS_VERSION = '3.64';

interface MedScoutMapsProviderProps {
  /** Extra Maps libraries to load, e.g. `['places']`. */
  libraries?: string[];
  children: ReactNode;
}

/**
 * The app's one `APIProvider` configuration: the Maps key and the pinned API
 * version. The Maps API script loads once per session, so the first provider
 * to mount wins and a later `version` prop is ignored. Territory Manager's
 * Draw/Radius tools need 3.64, which still ships the deprecated drawing
 * library, so every map root goes through this wrapper.
 */
export default function MedScoutMapsProvider({
  libraries,
  children,
}: MedScoutMapsProviderProps) {
  return (
    <APIProvider
      apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}
      version={GOOGLE_MAPS_VERSION}
      libraries={libraries}
    >
      {children}
    </APIProvider>
  );
}
